// function initVideoSwitcher() {
//     // Handle desktop video switching
//     document.querySelectorAll('.view-item.desktop').forEach(function(button) {
//       button.addEventListener('click', function() {
//         var videoUrl = this.getAttribute('data-video-desktop');
//         var videoElement = document.getElementById('product-video-desktop');
//         var imageUrl = this.getAttribute('data-image-desktop');
//         var imageElement = document.getElementById('product-image-desktop');
//         if (videoUrl && videoElement) {
//           videoElement.src = videoUrl;
//           videoElement.play();

//           document.querySelectorAll('.view-item.desktop').forEach(function(item) {
//             item.classList.remove('active');
//           });

//           this.classList.add('active');
//         }
//       });
//     });

//     // Handle mobile video switching
//     document.querySelectorAll('.view-item.mobile').forEach(function(button) {
//       button.addEventListener('click', function() {
//         var videoUrl = this.getAttribute('data-video-mobile');
//         var videoElement = document.getElementById('product-video-mobile');
        
//         if (videoUrl && videoElement) {
//           videoElement.src = videoUrl;
//           videoElement.play();

//           document.querySelectorAll('.view-item.mobile').forEach(function(item) {
//             item.classList.remove('active');
//           });

//           this.classList.add('active');
//         }
//       });
//     });
// }

// initVideoSwitcher();


{
  let bannerButtons = document.querySelectorAll('.js-banner-btn');
  let jsonScript = document.querySelector('.js-video-photo-json');
  let desktopSection = document.querySelector('.js-video-section-desktop');
  let mobileSection = document.querySelector('.js-video-section-mobile');

  let jsonData = JSON.parse(jsonScript.textContent);

  if (bannerButtons.length > 0 ) {
    bannerButtons.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        
        bannerButtons.forEach((button) => button.classList.remove('active'));
        event.target.classList.add('active');
        
        let viewName = event.target.getAttribute('data-banner-item');
        let isMobileView = event.target.getAttribute('data-is-mobile') === 'true';
        let content = jsonData[viewName];
        
        if (content) {
          if (isMobileView) {
            mobileSection.innerHTML = content;
          } else {
            desktopSection.innerHTML = content;
          }
        }
      });
    });

    if (window.matchMedia("(max-width: 749px)").matches) {
      let firstMobileButton = Array.from(bannerButtons).find(
        (btn) => btn.getAttribute('data-is-mobile') === 'true'
      );
      if (firstMobileButton) {
        firstMobileButton.click();
        firstMobileButton.classList.add('active');
      }
    } else {
      bannerButtons[0].click();
      bannerButtons[0].classList.add('active');
    }
  }
}


//`product_fit_range` is the dynamic value
setTimeout(function(){
  if(document.querySelectorAll('.slide_dot')){
    const dot = document.querySelectorAll('.slide_dot');
    dot.forEach(function(ele){
      const styleSheet = document.styleSheets[0];
      const product_fit_range = ele.getAttribute('data-ratio')
      const keyframes = `
        @keyframes slideLeftRight {
            0% {
                left: 50%;
            }            
        }
      `;
      styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
      ele.style.left = `${product_fit_range}%`;
      ele.style.animation = 'slideLeftRight 2s ease-in-out 1';
    });  
  }
},2000)


